import { render } from "./RenameMixin.vue?vue&type=template&id=3fd778fc"
import script from "./RenameMixin.vue?vue&type=script&lang=js"
export * from "./RenameMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__